/* esm.sh - @radix-ui/react-portal@1.1.10 */
export * from "/*@radix-ui/react-portal@1.1.10/esnext/react-portal.mjs";
